/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/communify_v2"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */

// jQuery(document).ready(function () {
// 	// Toggle on menu click
// 	jQuery("#menu-item-13").on("click", function (e) {
// 		e.stopPropagation(); // prevent bubbling so doc click won’t fire
// 		jQuery("#content").toggleClass("blur-effect");
// 	});

// 	// Close when clicking outside of ubermenu
// 	jQuery(document).on("click", function (e) {
// 		if (jQuery(e.target).closest("#menu-item-13, .ubermenu").length === 0) {
// 			jQuery("#content").removeClass("blur-effect");
// 		}
// 	});
// });



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

	jQuery(function ($) {
		// Delegated binding — works even if UberMenu inserts the item later
		$(document).on("click", "#menu-item-13", function (e) {
			e.stopPropagation();
			$("#content").toggleClass("blur-effect");
		});

		$(document).on("click", function (e) {
			if ($(e.target).closest("#menu-item-13, .ubermenu, .codesm-has-mega, .codesm-mega-panels-wrap").length === 0) {
				$("#content").removeClass("blur-effect");
			}
		});
	});



	

	// ✅ Reusable function
	function updateChevronListeners(swiper, containerId, prevClass, nextClass) {
		var prevBtn = document.querySelector(`${containerId} .swiper-pagination .${prevClass}`);
		var nextBtn = document.querySelector(`${containerId} .swiper-pagination .${nextClass}`);

		if (prevBtn) {
			prevBtn.onclick = function () {
				swiper.slidePrev();
			};
		}
		if (nextBtn) {
			nextBtn.onclick = function () {
				swiper.slideNext();
			};
		}
	}

	// ✅ Resources Carousel
	var resourcesCarousel = new Swiper('#resources-carousel .swiper', {
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		spaceBetween: 24,
		
		pagination: {
			el: '#resources-carousel .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return `
					<button class="resources-carousel-previous" aria-label="Previous Resource" ${current === 1 ? 'disabled' : ''}><img src="/wp-content/uploads/2025/09/swiper-arrow-left.svg"></button>
					<span>${current} / ${total}</span>
					<button class="resources-carousel-next" aria-label="Next Resource" ${current === total ? 'disabled' : ''}><img src="/wp-content/uploads/2025/09/swiper-arrow-right.svg"></button>
				`;
			}
		},
		breakpoints: {
			640: { slidesPerView: 1 },
			1024: { slidesPerView: "auto", spaceBetween: 30 },
			1200: { slidesPerView: "auto", spaceBetween: 30 },
			1440: { slidesPerView: "auto", spaceBetween: 30 }
		},
		on: {
			init: function () {
				setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
				updateChevronListeners(this, '#resources-carousel', 'resources-carousel-previous', 'resources-carousel-next');
			},
			slideChange: function () {
				updateChevronListeners(this, '#resources-carousel', 'resources-carousel-previous', 'resources-carousel-next');
			},
			paginationUpdate: function () {
				updateChevronListeners(this, '#resources-carousel', 'resources-carousel-previous', 'resources-carousel-next');
			}
		}
	});

	// ✅ MIND AI Carousel
	var mindAICarousel = new Swiper('.mindAI-carousel .swiper', {
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		spaceBetween: 24,
		
		pagination: {
			el: '.mindAI-carousel .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return `
					<button class="mindAI-carousel-previous" aria-label="Previous Slide" ${current === 1 ? 'disabled' : ''}><img src="/wp-content/uploads/2026/03/previous-button.png"></button>
					<span>${current} / ${total}</span>
					<button class="mindAI-carousel-next" aria-label="Next Slide" ${current === total ? 'disabled' : ''}><img src="/wp-content/uploads/2026/03/NEXT-BUTTON.png"></button>
				`;
			}
		},
		breakpoints: {
			640: { slidesPerView: 1 },
			1024: { slidesPerView: "auto", spaceBetween: 30 },
			1200: { slidesPerView: "auto", spaceBetween: 30 },
			1440: { slidesPerView: "auto", spaceBetween: 30 }
		},
		on: {
			init: function () {
				setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
				updateChevronListeners(this, '.mindAI-carousel', 'mindAI-carousel-previous', 'mindAI-carousel-next');
			},
			slideChange: function () {
				updateChevronListeners(this, '.mindAI-carousel', 'mindAI-carousel-previous', 'mindAI-carousel-next');
			},
			paginationUpdate: function () {
				updateChevronListeners(this, '.mindAI-carousel', 'mindAI-carousel-previous', 'mindAI-carousel-next');
			}
		}
	});
	


	// ✅ Financial Swiper
	var financialSwiper = new Swiper('#financialSwiper .swiper', {
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		spaceBetween: 24,
		// autoplay: {
		// 	delay: 10000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true
		// },
		pagination: {
			el: '#financialSwiper .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return `
					<button class="financialSwiper-previous" aria-label="Previous slide" ${current === 1 ? 'disabled' : ''}><img src="/wp-content/uploads/2025/09/swiper-arrow-left.svg"></button>
					<span>${current} / ${total}</span>
					<button class="financialSwiper-next" aria-label="Next slide" ${current === total ? 'disabled' : ''}><img src="/wp-content/uploads/2025/09/swiper-arrow-right.svg"></button>
				`;
			}
		},
		breakpoints: {
			640: { slidesPerView: 1 },
			1024: { slidesPerView: "auto", spaceBetween: 30 },
			1200: { slidesPerView: "auto", spaceBetween: 30 },
			1440: { slidesPerView: "auto", spaceBetween: 30 }
		},
		on: {
			init: function () {
				setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
				updateChevronListeners(this, '#financialSwiper', 'financialSwiper-previous', 'financialSwiper-next');
			},
			slideChange: function () {
				updateChevronListeners(this, '#financialSwiper', 'financialSwiper-previous', 'financialSwiper-next');
			},
			paginationUpdate: function () {
				updateChevronListeners(this, '#financialSwiper', 'financialSwiper-previous', 'financialSwiper-next');
			}
		}
	});

	// ✅ Digital Solutions Swiper
	var digitalSwiper = new Swiper('#digitalSolutionsSwiper .swiper', {
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		spaceBetween: 24,
		// autoplay: {
		// 	delay: 10000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true
		// },
		pagination: {
			el: '#digitalSolutionsSwiper .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return `
					<button class="digitalSolutionsSwiper-previous" aria-label="Previous slide" ${current === 1 ? 'disabled' : ''}><img src="/wp-content/uploads/2025/11/left-arrow.svg"></button>
					<span>${current} / ${total}</span>
					<button class="digitalSolutionsSwiper-next" aria-label="Next slide" ${current === total ? 'disabled' : ''}><img src="/wp-content/uploads/2025/11/right-arrow.svg"></button>
				`;
			}
		},
		breakpoints: {
			640: { slidesPerView: 1 },
			1024: { slidesPerView: "auto", spaceBetween: 30 },
			1200: { slidesPerView: "auto", spaceBetween: 30 },
			1440: { slidesPerView: "auto", spaceBetween: 30 }
		},
		on: {
			init: function () {
				setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
				updateChevronListeners(this, '#digitalSolutionsSwiper', 'digitalSolutionsSwiper-previous', 'digitalSolutionsSwiper-next');
			},
			slideChange: function () {
				updateChevronListeners(this, '#digitalSolutionsSwiper', 'digitalSolutionsSwiper-previous', 'digitalSolutionsSwiper-next');
			},
			paginationUpdate: function () {
				updateChevronListeners(this, '#digitalSolutionsSwiper', 'digitalSolutionsSwiper-previous', 'digitalSolutionsSwiper-next');
			}
		}
	});


	// ✅ Digital Solutions Swiper
	var mindAIMobileSwiper = new Swiper('#mindAIMobileSwiper .swiper', {
		direction: 'horizontal',
		grabCursor: true,
		slidesPerView: 1,
		watchSlidesProgress: true,
		observeParents: true,
		spaceBetween: 24,
		// autoplay: {
		// 	delay: 10000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true
		// },
		pagination: {
			el: '#mindAIMobileSwiper .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return `
					<button class="mindAIMobileSwiper-previous" aria-label="Previous slide" ${current === 1 ? 'disabled' : ''}><img src="/wp-content/uploads/2026/03/previous-button.png" style="width:32px; height:32px;"></button>
					<span>${current} / ${total}</span>
					<button class="mindAIMobileSwiper-next" aria-label="Next slide" ${current === total ? 'disabled' : ''}><img src="/wp-content/uploads/2026/03/NEXT-BUTTON.png" style="width:32px; height:32px;"></button>
				`;
			}
		},
		breakpoints: {
			640: { slidesPerView: 1 },
			1024: { slidesPerView: "auto", spaceBetween: 30 },
			1200: { slidesPerView: "auto", spaceBetween: 30 },
			1440: { slidesPerView: "auto", spaceBetween: 30 }
		},
		on: {
			init: function () {
				setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
				updateChevronListeners(this, '#mindAIMobileSwiper', 'mindAIMobileSwiper-previous', 'mindAIMobileSwiper-next');
			},
			slideChange: function () {
				updateChevronListeners(this, '#mindAIMobileSwiper', 'mindAIMobileSwiper-previous', 'mindAIMobileSwiper-next');
			},
			paginationUpdate: function () {
				updateChevronListeners(this, '#mindAIMobileSwiper', 'mindAIMobileSwiper-previous', 'mindAIMobileSwiper-next');
			}
		}
	});

	// animated-images-container
	const allContainers = document.querySelectorAll(".animated-images-container");
    const delayIncrement = 0.5; // Delay increment in seconds

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const container = entry.target;
                    const images = container.querySelectorAll("img");

                    images.forEach((image, index) => {
                        const delay = index * delayIncrement;
                        image.style.animationDelay = `${delay}s`;
                        image.style.animationPlayState = "running"; // Ensure animation starts
                    });

                    observer.unobserve(container); // Stop observing once animation has started
                }
            });
        },
        {
            root: null, // Default to viewport
            threshold: 0.1, // Trigger when 10% of the container is visible
        }
    );

    allContainers.forEach((container) => {
        const images = container.querySelectorAll("img");

        // Initially set animations to paused
        images.forEach((image) => {
            image.style.animationPlayState = "paused";
        });

        observer.observe(container); // Observe each container
    });
	
	/**
	 * ANIMATED COUNTER GROUP
	 */
	function createDigits(container, number, prefix, suffix) {
		let hasPrefix = false;
		let hasSuffix = false;

		if (prefix) {
			jQuery('<div>').addClass('animated-counter-digit').text(prefix).appendTo(container);
			hasPrefix = true;
		}

		number.toString().split('').forEach(function() {
			jQuery('<div>').addClass('animated-counter-digit').text('0').appendTo(container);
		});
		
		if (suffix) {
			suffix.split('').forEach(char => {
				jQuery('<div>').addClass('animated-counter-digit').text(char).appendTo(container);
			});
			hasSuffix = true;
		}		

		return { hasPrefix, hasSuffix };
	}

	function animateCounter(container, target, duration = 2000) {
		let startTime = null;
		let currentNumber = 0;
		const digitElements = container.find('.animated-counter-digit');
		const hasPrefix = container.data('counter-prefix') ? true : false;
		const hasSuffix = container.data('counter-suffix') ? true : false;

		function updateDigits(value) {
			const digits = value.toString().padStart(target.toString().length, '0').split('');
			const startIndex = hasPrefix ? 1 : 0;
			const endIndex = hasSuffix ? digitElements.length - 1 : digitElements.length;

			digitElements.slice(startIndex, endIndex).each(function(index) {
				jQuery(this).text(digits[index]);
			});
		}

		function animate(currentTime) {
			if (!startTime) startTime = currentTime;
			const progress = (currentTime - startTime) / duration;

			if (progress < 1) {
				currentNumber = Math.floor(target * progress);
				updateDigits(currentNumber);
				requestAnimationFrame(animate);
			} else {
				updateDigits(target);
			}
		}

		requestAnimationFrame(animate);
	}

	function isElementInViewport(el) {
		var rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	function handleScroll() {
		jQuery('[data-counter-target]').each(function() {
			var $this = jQuery(this);
			if (isElementInViewport(this) && !$this.data('animated') && !jQuery(window).data('allAnimated')) {
				var target = parseInt($this.data('counter-target'), 10);
				animateCounter($this, target);
				$this.data('animated', true);
			}
		});

		// Check if all counters have been animated
		if (jQuery('[data-counter-target]').length === jQuery('[data-counter-target][data-animated="true"]').length) {
			jQuery(window).data('allAnimated', true);
			jQuery(window).off('scroll', handleScroll);
		}
	}

	function initializeCounters() {
		jQuery('[data-counter-target]').each(function() {
			var $this = jQuery(this);
			var target = parseInt($this.data('counter-target'), 10);
			var prefix = $this.data('counter-prefix') || '';
			var suffix = $this.data('counter-suffix') || '';
			createDigits($this, target, prefix, suffix);
		});
	}

	if (jQuery('[data-counter-target]').length) {
		initializeCounters();
		jQuery(window).on('scroll', handleScroll);
		handleScroll();
		
		// Reset animation state on page reload
		jQuery(window).on('beforeunload', function() {
			jQuery(window).removeData('allAnimated');
		});
	}

	// ENABLE NEGATIVE MARGINS ON TABS CLICK
	jQuery(document).on('click', '.tabs-title', function() {
        enableNegativeMargins();
    });


	// const heroSwiper = new Swiper("#heroSwiper", {
	// 	spaceBetween: 15,
	// 	speed: 600,
	// 	direction: "horizontal",
	// 	loop: true,
	// 	freeMode: true,
	// 	slidesPerView: 'auto',
	// 	centeredSlides: true, 
		
	// 	on: {
	// 		slideChangeTransitionStart() {
	// 		this.slides[this.previousIndex].classList.remove('scale-up');
	// 		this.slides[this.previousIndex].classList.add('scale-down');
	// 		},
	// 		slideChangeTransitionEnd() {
	// 		this.slides.forEach(slide => {
	// 			slide.classList.remove('scale-down', 'scale-up');
	// 		});
	// 		this.slides[this.activeIndex].classList.add('scale-up');
	// 		},
	// 	},

	// });

});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */